import { Outlet, useRouteError, isRouteErrorResponse, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import ErrorBoundary from "@/components/ErrorBoundary";
import Button from "@/components/Button";
import { sendToRaygun } from "@/lib/raygunUtils";

const getErrorMessage = (error: unknown) => {
  if (isRouteErrorResponse(error)) {
    return error.statusText;
  } else if (error instanceof Error) {
    return error.message;
  } else if (typeof error === "string") {
    return error;
  } else {
    return "Unknown error";
  }
};

export const Catch = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    // Send the error to Raygun
    if (error) sendToRaygun(error, { tags: ["route-error"] });
  }, [error]);

  return (
    <ErrorBoundary
      className="mt-20 max-w-md mx-auto"
      title="Sorry, we need a mulligan"
      message={getErrorMessage(error)}
      image="default"
      action={
        <>
          <div className="flex gap-6 flex-col sm:flex-row">
            <Button onClick={() => navigate("/")}>Return To Home</Button>
          </div>
        </>
      }
    />
  );
};

const App = () => {
  return <Outlet />;
};

export default App;
